const photosTemplate = require('templates/widgets/stacking-grid/photos.hbs');
const indexTemplate = require('templates/widgets/stacking-grid/index.hbs');

if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }

const DEFAULTS = {
  numPhotos: 12,
  size: 'large'
};

L2H.StackingGridWidget = class StackingGridWidget extends L2H.Widget {
  constructor($container, photosURL, options) {
    super(...arguments);
    this.$container = $container;
    this.photosURL = photosURL;
    this.numPhotos = options.numPhotos || DEFAULTS.numPhotos;
    this.size = options.size || DEFAULTS.size;

    this.photos = [];

    this.renderIndex();

    this.modalView = new L2H.PhotoModalView(this.$container, 'stacking-grid-widget', null, options);

    this.fetchPhotos();
  }

  fetchPhotos() {
    this.fetchingPhotos = true;

    const self = this;

    return $.ajax({
      url: this.photosURL,
      data: {page: this.nextPage, per: this.numPhotos},
      dataType: "jsonp"
    }).done(function(data) {
      self.modalView.setPhotos(data.photos);
      $.merge(self.photos, data.photos);
      self.photos = data.photos;
      self.renderPhotos();

      let brokenPhotoChecker = new L2H.BrokenPhotoCheck();
      brokenPhotoChecker.call(data.photos);
    });
  }

  renderPhotos() {
    const renderedPhotos = photosTemplate({photos: this.photos, preferences: this.preferences});
    return this.$container.find('.l2h-photos').append(renderedPhotos);
  }

  renderIndex() {
    const renderedIndex = indexTemplate({numPhotos: this.numPhotos, size: this.size, preferences: this.preferences});
    return this.$container.html(renderedIndex);
  }
};
